// extracted by mini-css-extract-plugin
export default {"legacy":"Legacy_legacy__i-MUY","bigtitle":"Legacy_bigtitle__H5gVX","smallTitle":"Legacy_smallTitle__6aARw"};